/* eslint-disable react-hooks/exhaustive-deps */
import { useImmer } from "use-immer";
import {
  downloadReport,
  getAccountList,
  getListById,
  updateExcel,
  uploadExcel,
} from "../api/ListApis";
import { arraySort, errorMessage, successMessage } from "../../../utils";
import React, { useEffect } from "react";
import { useDebounce } from "use-debounce";
import qs from "qs";
import { useDropdownApis, usePermission, useTabs } from "../../../shared";
import { AppContext, AuthContext } from "../../../store";
import { useLocation, useNavigate } from "react-router-dom";
var fileDownload = require("js-file-download");

const defaultFilter = {
  options: {
    stores: [],
    financialYears: [],
    accountMonths: [],
  },
  values: { store: [], financialYear: [], month: [] },
  appliedFilters: [],
};

export const useList = ({ isList, detailsId, isStore }) => {
  const navigate = useNavigate();
  const { appState } = React.useContext(AppContext);
  const { auth } = React.useContext(AuthContext);
  const { globalData } = appState;
  const { listDetails: currentTab, uploadHistory } = appState.currentTabs;
  const { setCurentTab } = useTabs();

  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("/store-admin");

  const [state, setState] = useImmer({
    isBusy: false,
    isSearching: false,
    isRejectDialogOpen: false,
    isApproveDialogOpen: false,
    accountList: [],
    searchText: "",
    data: {
      store_id:
        isStoreAdmin && auth?.data?.selectedStoreId
          ? auth.data.selectedStoreId
          : "",
      month: "",
      year: "",
      excel_file: "",
    },
    file: "",
    filter: {
      options: {
        stores: [],
        financialYears: [],
        accountMonths: [],
      },
      values: { store: [], financialYear: [], month: [] },
      appliedFilters: [],
      isFilterApplied: true,
    },
  });

  const isCreateVisible = usePermission("pl-bs-account-create");
  const isEditable = usePermission("pl-bs-account-modify");

  const { storeList, franchiseeWiseStoreList } = useDropdownApis({
    isStoreList: isStore,
    isFranchiseeWiseStoreList: !isStoreAdmin && currentTab === "1",
  });

  const [debouncedText] = useDebounce(state.searchText, 1000);
  useEffect(() => {
    if (state.searchText !== null && !state.isSearching && isList) {
      accountList({ searchText: debouncedText });
    }
  }, [debouncedText, isList]);

  const accountList = async ({ searchText = "", filter = null }) => {
    try {
      setState((draft) => {
        draft.isBusy = true;
      });
      let params = {};
      if (searchText) {
        params = { ...params, search: searchText };
      }
      if (filter) params = { ...params, ...filter };

      if (isStoreAdmin && auth?.data?.selectedStoreId) {
        params.store_id = [auth.data.selectedStoreId];
      }

      const query = {
        params,
        paramsSerializer: (params) => qs.stringify(params, { encode: true }),
      };
      const res = await getAccountList(query);

      if (res.success) {
        setState((draft) => {
          draft.isBusy = false;
          draft.isSearching = false;
          draft.accountList = res.data;
          draft.filter.isFilterApplied = true;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.franchiseeDetails.isBusy = false;
        draft.isSearching = false;
      });
    }
  };

  const handleSearch = (v) => {
    setState((draft) => {
      draft.searchText = v;
    });
  };

  const onSeachClear = () => {
    setState((draft) => {
      draft.searchText = "";
    });
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState((draft) => {
      draft.data[name] = value;
    });
  };
  const getListDetails = async (detailsId) => {
    setState((draft) => {
      draft.isBusy = true;
    });
    try {
      const res = await getListById(detailsId);
      if (res.success) {
        setState((draft) => {
          draft.data = {
            ...res?.data,
            store_id: res?.data?.store_id,
            month: res?.data?.month,
            year: res?.data?.year,
            file: res?.data?.excel_file,
          };
          draft.isBusy = false;
        });
      }
    } catch (err) {
      setState((draft) => {
        draft.isBusy = false;
      });
    }
  };
  useEffect(() => {
    if (detailsId) {
      getListDetails(detailsId);
    }
  }, [detailsId]);

  const handleUploadExcel = async () => {
    let formData = new FormData();
    Object.keys(state.data).forEach((key) => {
      if (key !== "excel_file") {
        formData.append(key, state.data[key]);
      }
    });
    formData.append("excel_file", state.file);
    try {
      setState((draft) => {
        draft.isSaveButtonBusy = true;
      });
      const res = await uploadExcel(formData);
      if (res.success) {
        successMessage(
          res?.message ?? "PL & BS Account file uploaded successfully."
        );
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
        navigate(isStoreAdmin ? "/store-admin/list" : "/list");
      } else {
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });
    }
  };
  const handleUpdateUploadExcel = async () => {
    let formData = new FormData();

    state.file && formData.append("excel_file", state.file);
    formData.append("store_id", state.data.store_id);
    formData.append("month", state.data.month);
    formData.append("year", state.data.year);
    formData.append("_method", "put");
    try {
      setState((draft) => {
        draft.isSaveButtonBusy = true;
      });
      const res = await updateExcel(formData, detailsId);
      if (res.success) {
        successMessage(
          res?.message ?? "PL & BS Account file uploaded successfully."
        );
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
        navigate(isStoreAdmin ? "/store-admin/list" : "/list");
      } else {
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });
    }
  };
  const handleInputChangeFile = (e) => {
    setState((draft) => {
      draft.file = e?.target?.files[0];
    });
  };
  const handlePSAndBSReportList = async (id) => {
    try {
      const res = await downloadReport(id);
      const content = res.headers["content-type"];
      fileDownload(res.data, `PL&BS Report.xlsx`, content);
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };
  const handleOpenAlert = async (type, item) => {
    if (item === "reject") {
      setState((draft) => {
        draft.isRejectDialogOpen = type;
      });
    } else {
      setState((draft) => {
        draft.isApproveDialogOpen = type;
      });
    }
  };

  // ++++++++++++++++++++++++++++++++++++++++++++ Filter Updates +++++++++++++++++++++++++++++++++++++++++++++

  const convertFilterToAppliedFilter = (appliedFilter) =>
    Object.entries(appliedFilter).flatMap(([key, value]) =>
      value.map((item) => ({
        type: key.replace(key[0], key[0].toUpperCase()),
        label: item.label,
        accessorKey: key,
      }))
    );

  const handleChangeFilter = ({ name, value }) => {
    setState((draft) => {
      draft.filter.values[name] = value;
      draft.filter.isFilterApplied = false;
    });
  };

  const getAppliedFilter = (appliedFilters) => {
    setState((draft) => {
      draft.appliedFilters = appliedFilters;
    });
  };

  const getFilterParams = async (filterValues) => {
    const params = {};
    Object.entries(filterValues).forEach(([key, filter]) => {
      const actualKey =
        key === "store" ? "store_id" : key === "financialYear" ? "year" : key;
      filter.length > 0 &&
        (params[actualKey] = filter.map(({ value }) => value));
    });

    return params;
  };

  const handleApplyFilter = async (filters) => {
    const params = await getFilterParams(filters);
    await accountList({ filter: params });
  };

  const handleClearAllFilter = async (event) => {
    setState((draft) => {
      draft.filter.appliedFilters = [];
      draft.filter.values = defaultFilter.values;
    });

    await handleApplyFilter({});
  };

  const handleClearFilter = (props) => {
    handleChangeFilter({
      name: props.accessorKey,
      value: state.filter.values[props.accessorKey].filter(
        (item) => item.label !== props.label
      ),
    });
  };

  React.useEffect(() => {
    setState((draft) => {
      const accountMonthList = globalData?.pl_bs_reports?.pl_bs_accounts_months;
      const financialYearList = globalData?.pl_bs_reports?.pl_bs_accounts_years;

      if (accountMonthList) {
        const months = accountMonthList.map((month) => {
          const updatedMonth = {
            ...month,

            quarter:
              month.value <= 3
                ? "Q1"
                : month.value <= 6
                ? "Q2"
                : month.value <= 9
                ? "Q3"
                : "Q4",
          };

          return updatedMonth;
        });

        draft.filter.options.accountMonths = months;
      }
      if (financialYearList) {
        const years = financialYearList;
        draft.filter.options.financialYears = years;
      }
    });
  }, [globalData]);

  React.useEffect(() => {
    if (franchiseeWiseStoreList && !isStoreAdmin) {
      const stores = [
        ...franchiseeWiseStoreList.map((store, index) => ({
          label: store.name,
          value: store.id,
          franchisee_id: store.franchisee_id,
          franchisee_name: store.franchisee_name,
        })),
      ];
      setState((draft) => {
        if (franchiseeWiseStoreList.length > 0) {
          draft.filter.options.stores = arraySort(stores, "franchisee_name");
        }
      });
    }
  }, [franchiseeWiseStoreList]);

  React.useEffect(() => {
    getAppliedFilter(convertFilterToAppliedFilter(state.filter.values));
  }, [state.filter.values]);

  return {
    state,
    handleSearch,
    onSeachClear,
    storeList,
    handleInputChange,
    handleUploadExcel,
    handleInputChangeFile,
    handleUpdateUploadExcel,
    handlePSAndBSReportList,
    globalData,
    isCreateVisible,
    isEditable,
    currentTab,
    setCurentTab,
    handleOpenAlert,
    uploadHistory,
    handleChangeFilter,
    handleApplyFilter,
    handleClearAllFilter,
    handleClearFilter,
  };
};
